import './index.css'
import PlanningPoker from './components/PlanningPoker.tsx'

function App() {
  return (
    <div className="App">
      <PlanningPoker />
    </div>
  )
}

export default App 